import { render, staticRenderFns } from "./showquotedetail.vue?vue&type=template&id=e64aca40&"
import script from "./showquotedetail.vue?vue&type=script&lang=tsx&"
export * from "./showquotedetail.vue?vue&type=script&lang=tsx&"
import style0 from "./showquotedetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports